/**
 * @generated SignedSource<<c70c50e79b306a884eff6e13ee2d227d>>
 * @relayHash a85d80e9644ac82bc3331ce6167bfa89
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ebe7121b983c4524677472fc735a1be6892e0df1ceed2eb00faa41200d3a9f00

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSetDefaultNavigationItemInput = {
  id: string;
  scopeId?: string | null | undefined;
};
export type setAsDefaultItemOldMutation$variables = {
  input: JiraSetDefaultNavigationItemInput;
};
export type setAsDefaultItemOldMutation$data = {
  readonly jira: {
    readonly setDefaultNavigationItem: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly newDefault: {
        readonly id: string;
        readonly label: string | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"ui_navigationKitTabMenuOld_TabMenu">;
      } | null | undefined;
      readonly previousDefault: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ui_navigationKitTabMenuOld_TabMenu">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type setAsDefaultItemOldMutation = {
  response: setAsDefaultItemOldMutation$data;
  variables: setAsDefaultItemOldMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "label"
},
v5 = {
  "kind": "FragmentSpread",
  "name": "ui_navigationKitTabMenuOld_TabMenu"
},
v6 = {
  "kind": "ScalarField",
  "name": "message"
},
v7 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isJiraNavigationItem"
},
v10 = {
  "kind": "ScalarField",
  "name": "isDefault"
},
v11 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v12 = {
  "kind": "ScalarField",
  "name": "typeKey"
},
v13 = {
  "kind": "ScalarField",
  "name": "canRemove"
},
v14 = {
  "kind": "ScalarField",
  "name": "canSetAsDefault"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "setAsDefaultItemOldMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSetDefaultNavigationItemPayload",
            "kind": "LinkedField",
            "name": "setDefaultNavigationItem",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "name": "newDefault",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "previousDefault",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/)
                ]
              },
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "setAsDefaultItemOldMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSetDefaultNavigationItemPayload",
            "kind": "LinkedField",
            "name": "setDefaultNavigationItem",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "name": "newDefault",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "previousDefault",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v3/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v4/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/)
                ]
              },
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/)
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ebe7121b983c4524677472fc735a1be6892e0df1ceed2eb00faa41200d3a9f00",
    "metadata": {},
    "name": "setAsDefaultItemOldMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c8367bd6e7751463d79f52ede1a5fe37";

export default node;
